type Props = {};

const Bases = (props: Props) => {
  const containerStyle = {
    display: 'flex',
    justifyContent: 'justify',
  };

  const paragraphStyle = {
    flex: '1',
    textAlign: 'justify' as const,
    WebkitTextJustify: 'inter-word' as const,
    MozTextJustify: 'inter-word' as const,
    textJustify: 'inter-word' as const,
  };

  return (
    <div style={containerStyle}>
      <div style={paragraphStyle}>
        <p>
          A efectos de inscribirme en el concurso para la cobertura de el/los cargo/s a los que me
          postulo, declaro bajo juramento:
        </p>
        <ol>
          <li>
            Tener conocimiento de lo dispuesto por la Resolución Nº 82-E/2017 de la ex SECRETARÍA 
            DE EMPLEO PÚBLICO.
          </li>
          <li>
            Aceptar y conocer las condiciones exigidas por la Resolución Nº 82-E/2017 de la ex 
            SECRETARÍA DE EMPLEO PÚBLICO, asi como el procedimiento fijado por la mencionada 
            resolución y los alcances que la misma posee dentro del presente proceso.
          </li>
          <li>Satisfacer los requisitos mínimos excluyentes, establecidos en el perfil del 
            puesto al cual me postulo.
          </li>
          <li>
            Aceptar y conocer las Bases del Concurso del cargo al que me inscribo en este acto;
            tomando conocimiento del cronograma y metodología de las etapas del proceso, de las 
            materias o temáticas a abordar en la(s) prueba(s) y entrevista(s) fijadas, de los 
            puntajes a asignar a las diversas características a considerar, con los cambios que 
            pudiera resolver el Comité de Selección y/o el Coordinador Concursal, en caso de 
            corresponder, a los efectos de mejor proveer, y que serán comunicados con la 
            antelación suficiente, como asimismo el sitio web en la que se divulgarán las 
            informaciones y los resultados respectivos.
          </li>
          <li>
            Aceptar que las comunicaciones y notificaciones a que dé lugar el desarrollo del 
            proceso al que me inscribo en este acto, puedan ser efectuadas indistintamente en 
            la dirección domiciliaria y/o electrónica que he declarado en la presente 
            inscripción. 
          </li>
          <li>
            Que los datos consignados en las solapas “Mi Perfil” y “CV” del sitio web CONCURSAR, 
            son completos, verdaderos y atinentes al perfil del puesto de trabajo o función a 
            concursar, y que cualquier inexactitud en los datos declarados y/o documentados, 
            serán causal suficiente para la exclusión del aspirante/postulante.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default Bases;